
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interventions",
      function () {
        return require("private-next-pages/interventions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interventions"])
      });
    }
  